import { useState } from "react";
import FormDetails from "./FormDetails";
import { useAuth } from "../../context/AuthProvider";
import axios from 'axios';
import Success from "./Success";

export default function Form() {
    const { user } = useAuth();
    const [ request, setRequest ] = useState({
        employee: user._id,
        phone: '',
        mail: ''
    });
    const [ message, setMessage ] = useState(null);
    const [ success, setSuccess ] = useState(false);
    const handleSubmit = async e => {
        e.preventDefault();
        try {
            await axios({
                method: 'post',
                url: 'https://signupapp-backend-app-9b09cbe965e9.herokuapp.com/api/restricted/new-contact',
                data: request
            }).then(response => {
                setMessage(response.data.message);
                setSuccess(true);
                setTimeout(() => {
                    setSuccess(false);
                    setRequest({
                        employee: user._id,
                        phone: '',
                        mail: ''
                    });
                    setMessage(null);
                }, 5000);
            })
        } catch(error) {
            console.log(error)
        }
    };
    return (
        <>
            {success ? (
                <Success/>
            ) : (
                <form onSubmit={handleSubmit}>
                    <FormDetails request={request} setRequest={setRequest} />
                </form>
            )}
        </>
    );
}